import uiarticlebyline from './uiarticlebyline.js'

// Filename: uiarticleprev.js
// Timestamp: 2017.11.19-13:41:57 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

// awkward canvas when container is resized to proportions
// different from those used on initial canvas 'render'
//
// canvas kept inside container w/ overflow:hidden
// canvas resized to 'fit' container on resize
const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const tags = cfg.h
  const article = tags.article(nd)
  const { b, p, a, span, time, header } = tags
  const {
    title,
    author,
    href,
    posterimg,
    excerptnohtml,
    datepublished
  } = subj
  const isexce = Boolean(excerptnohtml)
  const isfeat = Boolean(subj.isfeature)
  const h2ORh3 = (isfeat ? tags.h2 : tags.h3)(nd)

  return (
    article(`ui:.st-isexcerpt-${isexce}.st-isfeature-${isfeat}`, [
      header([
        h2ORh3('ui-details-title:', [
          a({
            href,
            title: excerptnohtml || title
          }, title)
        ]),
        uiarticlebyline(cfg, [
          b(author),
          time(datepublished)
        ])
      ]),

      a('.poster', {
        href,
        title: excerptnohtml || title,
        style: posterimg ? {
          'background-image': `url('${posterimg}')`
        } : {}
      }),

      isfeat && p([
        span(excerptnohtml + ' '),
        a({
          href,
          title
        }, 'Read more …')
      ])
    ])
  )
}

export default {
  type: 'uiarticleprev',
  xvnode
}
